import {Alert, Span} from '@chakra-ui/react'
import {getDatetimeFormatter} from '@cypro/ui/utils'
import {TFnType, useTranslate} from '@tolgee/react'
import {useEffect, useState} from 'react'

/** "24/10/2026, 01:28 · 2h 10m left", or in red with "· Expired" once the use-by has passed. */
export function UseByValue({useBy}: {useBy: number | null}) {
  const {t} = useTranslate('common')
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30_000)
    return () => clearInterval(id)
  }, [])

  if (!useBy) return <Span color="fg.muted">-</Span>

  const remaining = useBy - now
  const isExpired = remaining <= 0

  return (
    <Span color={isExpired ? 'red.fg' : undefined}>
      {getDatetimeFormatter().format(useBy)}
      <Span color={isExpired ? 'red.fg' : 'fg.muted'}>
        {' · '}
        {isExpired ? t('use_by_expired') : formatRemaining(remaining, t)}
      </Span>
    </Span>
  )
}

function formatRemaining(ms: number, t: TFnType) {
  const totalMinutes = Math.max(0, Math.floor(ms / 60_000))
  const days = Math.floor(totalMinutes / 1440)
  const hours = Math.floor((totalMinutes % 1440) / 60)
  const minutes = totalMinutes % 60

  return days > 0 ? t('days_hours_left', {days, hours}) : t('hours_minutes_left', {hours, minutes})
}

/** Shown where a nurse would confirm the administration of an expired bag (CY-327). */
export function PreparationExpiredAlert() {
  const {t} = useTranslate('common')

  return (
    <Alert.Root size="sm" colorPalette="red" borderRadius="l2">
      <Alert.Indicator />
      <Alert.Content>
        <Alert.Title fontSize="xs">
          {t('preparation_expired_blocked', 'Preparation expired: it cannot be released or administered')}
        </Alert.Title>
        <Alert.Description fontSize="xs">
          {t('preparation_expired_return', 'Do not administer. Return the preparation to the pharmacy.')}
        </Alert.Description>
      </Alert.Content>
    </Alert.Root>
  )
}
